import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconCircleCheckProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconCircleCheck: React.FC<IconCircleCheckProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Approve',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="m9 12 2 2 4-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconCircleCheck;
